import request from '@/router/axios'

// workerForm流程下载接口
export const downLoadWorkerForm = params => request({
  url: '/api/mcc-worker/processfield/DaoChuFormPerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '30',
    ...params,
  },
})

// workerForm流程全部导出接口
export const downLoadAllWorkerForm = params => request({
  url: '/api/mcc-worker/processfield/DaoChuForm',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '30',
    ...params,
  },
})

// 离职流程下载接口
export const downLoadLeaveJob = params => request({
  url: '/api/mcc-worker/processfield/DaoChuLeavePerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '24',
    ...params,
  },
})

// 离职流程全部导出接口
export const downLoadAllLeaveJob = params => request({
  url: '/api/mcc-worker/processfield/DaoChuLeave',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '24',
    ...params,
  },
})

// 请假流程全部导出接口
export const downLoadAllLeave = params => request({
  url: '/api/mcc-worker/processfield/DaoChuLeaveApplication',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '29',
    ...params,
  },
})

// 请假流程下载接口
export const downLoadLeave = params => request({
  url: '/api/mcc-worker/processfield/DaoChuLeaveApplicationPerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '29',
    ...params,
  },
})

// 自定义下载
export const customDownload = (url, params, responseType) => request({
  url: `/api${url}`,
  method: 'post',
  responseType,
  params: {
    ...params,
  },
})
